<template>
    <div>
        <ts-loading-banner :loading="loadingPreData">
            <div v-if="edit_data && Object.keys(edit_data).length > 0">
                <h1 class="page-header">
                    <a href="#" @click.prevent="$router.push({ name: 'eventManagement' })" class="mr-2">
                        <i class="fas fa-arrow-left"></i>
                    </a>
                    {{ edit_data.event_name || '-' }}
                </h1>
                <div class="d-flex justify-content-end">
                    <ts-breadcrumb :items="breadcrumbItems" />
                </div>
            </div>
            <p v-else>Loading event data...</p>

            <div class="row" v-if="edit_data && Object.keys(edit_data).length > 0">
                <div class="col-lg-4 col-md-5 col-sm-12">
                    <ts-card>
                        <ts-card-wrapper>
                            <event-management v-model="edit_data" />
                        </ts-card-wrapper>
                    </ts-card>
                    <br />
                </div>
                <div class="col-lg-8 col-md-7 col-sm-12">
                    <ts-card>
                        <ts-card-wrapper>
                            <student-list :event-id="edit_data.event_mgt_id" :value="edit_data.registrations || []" />
                        </ts-card-wrapper>
                    </ts-card>
                </div>
            </div>
        </ts-loading-banner>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import EventManagement from './components/event-management.vue'
import StudentList from './components/view-student-list.vue'

export default {
    components: { EventManagement, StudentList },
    data() {
        return { loadingPreData: false }
    },
    computed: {
        ...mapState('eventManagement', ['edit_data']),

        breadcrumbItems() {
            return [
                { text: this.$t('toHomePage'), href: '/' },
                { text: this.$t('eventManagement.pageTitle'), href: '/' }
            ]
        }
    },
    async mounted() {
        const eventId = this.$route.params.id
        if (eventId && (!this.edit_data || this.edit_data.event_mgt_id !== eventId)) {
            this.loadingPreData = true
            try {
                await this.fetchEvent(eventId)
            } catch (err) {
                console.error('Failed to load event:', err)
            } finally {
                this.loadingPreData = false
            }
        }
    },
    methods: {
        ...mapActions('eventManagement', ['fetchEvent'])
    },
    beforeRouteLeave(to, from, next) {
        if (!to.params.id) {
            this.$store.commit('eventManagement/RESET_STATE')
        }
        next()
    }
}
</script>
